import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import * as Util from '../../../util';
import { connectToUser } from '../../User/containers/UserDataStore';

const CommunityReviewsContext = React.createContext();

export const useCommunityReviews = () =>
	React.useContext(CommunityReviewsContext);

const name = 'communityReviewsDataStore';

export const connectToCommunityReviews = makeConnectTo(
	CommunityReviewsContext,
	name,
);

class CommunityReviewsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		userDataStore: PropTypes.object,
	};

	state = {
		titles: [],
		isLoading: true,
		skus: {},
		conversations: {},
		areConversationsLoading: true,
	};

	render() {
		const communityReviewsDataStore = this.getStore();
		return (
			<CommunityReviewsContext.Provider value={communityReviewsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(communityReviewsDataStore)
					: this.props.children}
			</CommunityReviewsContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCommunityReviews();
	}

	componentWillUnmount() {
		if (this.communityReviewsFetch && this.communityReviewsFetch.cancel) {
			this.communityReviewsFetch.cancel();
		}
		if (this.conversationsFetch && this.conversationsFetch.cancel) {
			this.conversationsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshCommunityReviews(),
		fetchConversationStatus: () => this.fetchConversationStatus(),
	});

	refreshCommunityReviews = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchCommunityReviews();
		return this.communityReviewsFetch.promise;
	};

	fetchCommunityReviews = () => {
		const {
			communityId,
			maxTitles,
			userDataStore: { isAnonymous },
		} = this.props;
		const communityIdentifier =
			isAnonymous() && communityId === 0 ? 'genres' : communityId;
		const request = api.cancelableGet(
			`/api/v1/affiliations/${communityIdentifier}/buzz?maxTitles=${maxTitles}`,
		);
		request.promise.then(this.cacheApiResponse);
		this.communityReviewsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const {
			userDataStore: { isAnonymous },
		} = this.props;
		const titles = apiResponse ? Util.createTitleObject(apiResponse) : [];
		this.setState({ titles, isLoading: false, skus: this.getSkus(titles) });
		!isAnonymous() && this.fetchConversationStatus();
	};

	getSkus = titles => {
		return titles && titles.map(item => item.sku);
	};

	fetchConversationStatus = () => {
		const { communityId } = this.props;
		const { skus } = this.state;

		const request = api.cancelablePost(
			`/api/v1/conversations/${communityId}/titles`,
			skus,
		);
		request.promise.then(this.cacheConversationApiResponse);
		this.conversationsFetch = request;
	};

	cacheConversationApiResponse = apiResponse => {
		this.setState({
			conversations: apiResponse,
			areConversationsLoading: false,
		});
	};
}

export default connectToUser(CommunityReviewsDataStore);
